import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private clientConfigurationSource = new BehaviorSubject<ClientConfiguration>(null);
  clientConfiguration = this.clientConfigurationSource.asObservable();

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  async loadConfiguration() {
    console.info("loadConfiguration called!");
    return this.http.get<ClientConfiguration>(`${this.baseUrl}api/configuration`)
      .toPromise()
      .then(
        result => {
          console.info("result is good!");
          this.clientConfigurationSource.next(<ClientConfiguration>(result));
        },
        error => console.error(error)
      );
  }
}

export interface ClientConfiguration {
  noticeUrlPrefix: string,
  noticeUrlPostfix: string,
  createNoticeUrl: string
}
